export const MODULE_NAME = 'download';

export const DOWNLOAD_ALL = 'downloadAll';
export const SET_DOWNLOAD_ALL = 'setDownloadAll';
